import styled from "styled-components";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { colors, types } from "../../../libs";

export const ProgramModal = styled(Modal)`
  .modal-dialog {
    max-width: 760px;
  }
  .modal-content {
    background: transparent;
    border: none;
  }
`;

export const ModalWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.background.lightBlack};
  border-radius: 8px;
  max-height: 90vh;
  overflow-y: auto;
  scrollbar-color: ${colors.background.darkGreen} transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.background.darkGreen};
    border-radius: 10px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.div`
  ${types.body.secondaryTitle};
  color: ${colors.text.white};
  font-weight: bold;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.white};
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
  @media (max-width: 700px) {
    grid-column: auto;
  }
`;

export const Field = styled.div`
  width: 100%;
`;

export const FieldLabel = styled.div`
  ${types.body.normal};
  color: ${colors.text.disabled};
  margin: 0 0 6px 5px;
`;

export const HelpText = styled.div`
  ${types.body.small};
  color: ${colors.text.disabled};
  margin-top: 6px;
`;

export const CustomDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 15px;
  border-radius: 0.25rem;
  background: ${colors.background.formField};
  outline: none;
  border: 1px solid transparent;
  color: ${colors.text.white};
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }
  .react-datepicker-popper {
    z-index: 1060;
  }
`;

export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  padding: 0 10px;
  background: ${colors.background.formField};
`;

export const SwitchLabel = styled.div`
  ${types.body.normal};
  color: ${colors.text.disabled};
  margin-left: 5px;
`;

export const UrlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const UrlInput = styled.input`
  flex: 1;
  padding: 12px 15px;
  border-radius: 2px;
  border: 1px solid transparent;
  background: ${colors.background.formField};
  color: ${colors.text.white};
  &:focus {
    outline: none;
    border-color: ${colors.background.green};
  }
`;

export const IconButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: ${colors.background.lightGrey};
  color: ${colors.text.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Footer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const ButtonSlot = styled.div`
  flex: 1;
`;
